module.exports = __webpack_public_path__ + "static/media/background@2x.2a62ec01.png";